export type CabotageOperationItemData = {};

export type CabotageOperationPagination = {
  "@id": string;
  type: string;
  first: string;
  last: string;
  previous: string;
  next: string;
};

export type CabotageOperationSearchMappingItem = {
  "@type": string;
  variable: string;
  property: string;
  required: boolean;
};

export type CabotageOperationSearch = {
  "@type": string;
  template: string;
  variableRepresentation: string;
  mapping: CabotageOperationSearchMappingItem[];
};

export type CabotageOperationListResponse = {
  member: CabotageOperationItemData[];
  totalItems: number;
  view: CabotageOperationPagination;
  search: CabotageOperationSearch;
};

export type CabotageOperationPageState = {
  page: number;
  itemsPerPage?: number;
  pagination: boolean;
  name?: string | null;
  address?: string | null;
  reference?: string | null;
  q?: string | null;
  order?: { dataKey: string; order?: "asc" | "desc" };
};

export type CabotageOperationListStateType = {
  pageState: CabotageOperationPageState;
  setPageState: (state: CabotageOperationPageState) => void;
};

export const initialCabotageOperationPageState: CabotageOperationPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};

/***
 *
 *
 */

export type OperationItemType = {
  "@context"?: string;
  "@id"?: string;
  "@type"?: "Operation";
  reference?: string;
  operationCategory?: {
    "@id"?: string;
    "@type"?: "OperationCategory";
    name?: string;
    id?: string;
  };
  operationType?: {
    "@id"?: string;
    "@type"?: "OperationType";
    name?: string;
    id?: string;
  };
  operationShifting?: {
    "@id"?: string;
    "@type"?: "OperationShifting";
    name?: string;
    id?: string;
  };
  manifestFile?: FileMedia;
  teamOrderFile?: FileMedia;
  arrivalNoticeFile?: FileMedia;
  receiptRequestAt?: string;
  customer?: Customer;
  ship?: string;
  travelReference?: string;
  estimatedArrivalAt?: string;
  startAt?: string;
  debarkationMovement?: Movement;
  embarkationMovement?: Movement;
  holds?: number[];
  teams?: any[]; // Define a more specific type if needed
  id?: number;
  debarkation?: boolean;
  embarkation?: boolean;
};

type FileMedia = {
  "@id"?: string;
  "@type"?: "FileMedia";
  contentUrl?: string;
  size?: number;
  mimeType?: string;
};

type Customer = {
  "@id"?: string;
  "@type"?: "Customer";
  name?: string;
  id?: number;
};

type Movement = {
  "@id"?: string;
  "@type"?: string;
  id?: number;
  customerShipowner?: Customer;
};
